import { get } from 'lodash'

export default (docType: string, marketing: any, reportType = '') => {
  const isJapanese = get(marketing, 'language.slug') === 'ja'

  const commentaryTypes = [
    'NON-RATING ACTION COMMENTARY',
    'RATING ACTION COMMENTARY'
  ]

  const type = reportType && reportType.toUpperCase()

  const reportTypeHeader =
    isJapanese && commentaryTypes.includes(type) ? 'Commentary' : reportType

  return docType === 'FW' && type === 'NON-RATING ACTION COMMENTARY'
    ? 'Fitch Wire'
    : reportTypeHeader
}
